<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" id="topBar">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices"  style="max-width:150px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                 <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"    @change="getFactorsByMn"  style="max-width:200px"  filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"   @change="getFactorsByMn" style="max-width:160px"  filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptionsHour" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"   style="max-width:340px" align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
                     <form-query-button  @select-type="getDataList" >  </form-query-button>
				</el-form-item>
			</el-form>
		</el-col>

        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading">
            <div id="chartLine">
                <iframe id = "child" src="../../../static/rose.html" width="100%" :height="formHeight" frameborder="0" scrolling="no" style="position:related;top: 2.8px;left: 0px;"></iframe>
            </div>
        </el-col>

	</section>
</template>

<script>
    import util from '../../common/js/util'
	import { getProjects,getDevicesByProjectId,selectNoiseDataForTime,getFactorsByMn} from '../../api/api';
    import {formatDate,getIcons} from '../../../static/fun.js';
    import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

	export default {
        components: { FormQueryButton },
		data() {
			return {
                pickerOptionsHour: {
                    shortcuts: [ {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.setMonth(start.getMonth()-1));
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.setMonth(start.getMonth()-3));
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近六个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.setMonth(start.getMonth()-3));
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.setMonth(start.getMonth()-12));
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
                    mn:"",
                    facKeyword:[],
					time:[]
				},
                listLoading: false,
                chartLine:null,
				devices:[],
                facList:[],
                factors:[],
                data:[],
                dataType:"day",
				projects:[],
                firstFlag:true,
                formHeight:0,
                chooseMn:this.$route.query.mn||"",
                choosePro:this.$route.query.projectId||"",

                type:1,
                color: ['#4fa8f9','#6ec71e'],
			}
        },
		methods: {
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
                    
                    if(this.chooseMn){
                        this.filters.projectId=this.choosePro;
                        this.filters.mn=this.chooseMn;
                    }
			        else if(this.projects.length>0){
                         this.filters.projectId=this.projects[0].projectId;
                    }
                    this.getDevices();                   
				});
			},
			//获取设备列表
			getDevices() {
                this.count++;
                let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
                    
                    this.devices = res.data.data;
					if(this.devices.length>0&&this.chooseMn==""){
                        this.filters.mn=this.devices[0].mnCode;
                    }
					this.getFactorsByMn();
				});
            },
            //获取选中设备可监测的因子
            getFactorsByMn(){
                 let para = {
                    mn: this.filters.mn,
                    dataType:this.dataType
                };
				getFactorsByMn(para).then((res) => {
                    
                    this.factors = res.data.data;
                    this.filters.facKeyword=[];
                    var count=0;
                    if(this.factors.length>0){
                        this.factors.forEach(element => {
                            if(element.keyword=="a01007"||element.keyword=="a01008"){
                                count++;
                                this.filters.facKeyword.push(element.keyword);
                            }
                        });
                    } 
                    if(count<2){
                          this.$message({
                            message: "选择点位中不含风速或者风向，请重新选择",
                            type: 'error'
                        })
						return;
                    }
                    if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取趋势分析数据
            getDataList(){
                if(this.filters.facKeyword.toString()==""){
                    this.$message({
						message: "设备因子不能为空",
						type: 'error'
					})
					return;
                }
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
                    endtime=formatDate(this.filters.time[1]);
                }
                this.chooseMn="";
                this.choosePro="";
                let para = {
                    mn: this.filters.mn,
                    dataType:this.dataType,
                    factorId: this.filters.facKeyword.toString(),
                    startDate: starttime,
                    endDate: endtime,
                    linkage: false
                };
                this.listLoading = true;
                
                //数据格式处理
				selectNoiseDataForTime(para).then((res) => {
                    this.listLoading = false;
                    
                    this.data = res.data[para.mn]["a01007"];
                    var a01008List=res.data[para.mn]["a01008"];
                    //对获取的实时数据进行循环
                    let data1=[0,0,0,0,0,0,0,0];
                    let data2=[0,0,0,0,0,0,0,0];
                    let data3=[0,0,0,0,0,0,0,0];
                    let data4=[0,0,0,0,0,0,0,0];
                    let data5=[0,0,0,0,0,0,0,0];
                    let data6=[0,0,0,0,0,0,0,0];
                    let data7=[0,0,0,0,0,0,0,0];
                    var i=0;
                    this.data.forEach((item) => {
                        var ws=item;
                        var wd=a01008List[i];
                        if(ws<0.5)  data1=this.getWd(data1,wd); 
                        else if(ws<2)  data2=this.getWd(data2,wd); 
                        else if(ws<4)  data3=this.getWd(data3,wd); 
                        else if(ws<6)  data4=this.getWd(data4,wd); 
                        else if(ws<8)  data5=this.getWd(data5,wd); 
                        else if(ws<10)  data6=this.getWd(data6,wd); 
                        else  data7=this.getWd(data7,wd); 

                        i++;
                    });
                    document.getElementById('child').src='../../../static/rose.html?height='+this.formHeight+"&len="+ this.data.length
                    +"&data1="+data1+"&data2="+data2+"&data3="+data3+"&data4="+data4+"&data5="+data5+"&data6="+data6+"&data7="+data7;
				});
            },
            getWd(data,wd){
                if ((wd >= 0 && wd <= 23) || (339 <= wd && wd <= 360))  data[0]++;
                else if (wd <= 68) data[1]++;
                else if (wd <= 113) data[2]++;
                else if (wd <= 158) data[3]++;
                else if (wd <= 203) data[4]++;
                else if (wd <= 248) data[5]++;
                else if (wd <= 293) data[6]++;
                else if (wd <= 338) data[7]++;

                return data;
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
            var end = new Date();
			var start = new Date();
			//设置不同的时间区间
            start.setTime(start.setMonth(start.getMonth()-1));
            this.filters.time= [formatDate(start), formatDate(end)];
            this.getProjects();

            //窗口大小改变时
            window.onresize = function(){
                var chartLineDiv=document.getElementById("chartLine");
                var hightNow=document.body.clientHeight-200;
                if(chartLineDiv!=null){
                    chartLineDiv.style.height=hightNow+"px";
                }
            }
		}
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// Rose.vue?79a94ee9